// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */
import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import {extractCaller} from "../QueryPage";
import type {GenericModalDispatchProps, GenericModalStateProps} from "../../components/GenericModal";
import GenericModal from "../../components/GenericModal";
import type {Caller} from "../../components/QueryPage";
import EBadge from "../../model/ebadge/EBadge";
import {closeEBadgeButtonModalAction, eBadgeButtonAction} from "../../actions/ebadge/creators/eBadgeButtonActionCreator";
import {changeEBadgeVerificationStatus} from "../../dao/eBadgeDao";

function getIsLoadingStatus(state, registrationCode) {
    let status = state.eBadgeAction['validate'] && state.eBadgeAction['validate'][registrationCode];
    if (status) {
        return status.isLoading;
    } else {
        return false;
    }
}

type Args = {
    registrationCode: string,
    caller: Caller
}

const mapStateToProps = (state: StoreState): GenericModalStateProps => {

    const registrationCode = state.modal['validate'] && state.modal['validate'].identifier;
    const isLoading = registrationCode ? getIsLoadingStatus(state, registrationCode)
        : false;

    const args: Args = {
        registrationCode: registrationCode || '',
        caller: extractCaller(state)
    };
    return {
        open: state.modal['validate'] && state.modal['validate'].open,
        promptMsg: `Are you sure to validate ${registrationCode || 'EBadge'}? `,
        loadingMsg: `OK. We are validating ${registrationCode || 'EBadge'}`,
        isLoading,
        error: state.eBadgeAction['validate'] && state.eBadgeAction['validate'].error,
        primaryActionText: 'Validate',
        primaryActionColor: "success",
        primaryActionClassName: "light-green",
        args: args
    }
};

const mapDispatchToProps = (dispatch): GenericModalDispatchProps => {
    return {
        primaryAction: (args: Args) => {
            dispatch(eBadgeButtonAction(args.registrationCode, args.caller, "validate",
                async (registrationCode, caller, authToken) => {
                    return await changeEBadgeVerificationStatus(registrationCode, caller, authToken, "Y")
                }));
        },
        closeModal: () => {
            dispatch(closeEBadgeButtonModalAction("validate"));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(GenericModal);



// WEBPACK FOOTER //
// ./src/containers/ebadge/ValidateEBadgeModal.js